import React
    from "react";

const ErrorContainer = ({
                            children,
                            ...rest
                        }) => {
    return (
        <div className='fz-form-field-error-container' {...rest}>
            {children}
        </div>
    )
}

export default ErrorContainer;